import { useEffect } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { BusinessRelationshipEnum } from "~/__generated__/graphql"
import {
  onboardingChoosePlanPath,
  onboardingPersonalDetailsPath,
} from "~/common/paths"
import { useCurrentUserMaybe } from "../auth/CurrentUserContext"

export const RequireUserOnboardedAndSubscribed = () => {
  const navigate = useNavigate()
  const { currentUser, result } = useCurrentUserMaybe()

  useEffect(() => {
    if (result.loading) return
    if (currentUser?.isAdmin) return

    const isFreeAgency =
      currentUser?.agency?.businessRelationship ===
      BusinessRelationshipEnum.Free
    const hasSubscription = Boolean(currentUser?.activeSubscription)
    const isOnboarded = Boolean(currentUser?.isOnboarded)

    // User is onboarded and either has free access or paid subscription
    if (isOnboarded && (isFreeAgency || hasSubscription)) {
      return
    }

    // User is onboarded but needs to select a subscription (free → standard transition)
    if (isOnboarded && !isFreeAgency && !hasSubscription) {
      navigate(onboardingChoosePlanPath({}))
      return
    }

    navigate(onboardingPersonalDetailsPath.pattern)
  }, [currentUser, result.loading, navigate])

  if (result.loading) {
    return null
  }

  return <Outlet />
}
